export class Point {
  constructor() {}
  type = 'Point';
  coordinates = [];
}
